import { useAppSelector } from '@redux/hooks';
import { getParams } from '@entities/Filter';
import { useEffect, useState } from 'react';

export const useGetValueParam = (name: string) => {
  const params = useAppSelector(getParams);
  const [value, setValue] = useState();
  useEffect(() => {
    setValue(params[name]);
  }, [params[name]]);

  return value;
};
